export const getProfessionalPriceId = () => {
    if (!window.location.host || window.location.host.includes("localhost") || window.location.host.includes("yellow-cliff") ||
    window.location.host.includes("staging")) {
      return "price_1NXS5SBREB9vAfzdjFh13OCV";
    }
    //production
    return "price_1NYwb8BREB9vAfzdYEnLlJNS";
  }